import { useApi } from '../../api/api-context';
import { useQueryMutation } from '../../api/use-query-mutation';
import { useBudgetId } from '../../budget/budget-store';
import { logAndThrowError } from '../../utils/errors';
export const useUpdateAccountApi = (options) => {
    const api = useApi();
    const budgetId = useBudgetId();
    const queryKey = ['accounts', budgetId];
    // api call
    const updateAccountApi = async (data) => {
        await api.put('/account', data);
    };
    // optimistic update
    const onMutate = (oldData, request) => {
        if (!oldData) {
            logAndThrowError('No accounts data found');
        }
        const accountIndex = oldData.findIndex((account) => account.id === request.id);
        if (accountIndex === -1) {
            logAndThrowError('Account not found');
        }
        // Create a new array with the updated account
        const newData = [...oldData];
        newData[accountIndex] = {
            ...oldData[accountIndex],
            ...request,
        };
        return newData;
    };
    return useQueryMutation(updateAccountApi, queryKey, onMutate, options);
};
